module.exports = __webpack_public_path__ + "static/media/seb-logo.0e41ec16.svg";